import RFV from "./RFV";
// import { ProfileType } from "@components/Icons";
import styles from "@styles/containers/oraculo/customer-drawer/data-tab.module.scss";
import { Phone } from "@utils/Phone";
import classNames from "classnames/bind";

const css = classNames.bind(styles);

const RFV_LABELS = {
  CAMPEOES: "Campeões",
  HIBERNANDO: "Hibernando",
  PROMISSORES: "Promissores",
  LEAL: "Leal",
  EM_RISCO: "Em risco",
  REQUER_ATENCAO: "Requer atenção",
  DESLIGANDO: "Desligando",
  ABANDONADOS: "Abandonados",
  INDEFINIDO: "Indefinido",
};

const css_classes = {
  CAMPEOES: "campeoes",
  HIBERNANDO: "hibernando",
  PROMISSORES: "promissores",
  LEAL: "leais",
  EM_RISCO: "emrisco",
  REQUER_ATENCAO: "naopodemosperder",
  DESLIGANDO: "perfilindefinido",
  ABANDONADOS: "perfilindefinido",
  INDEFINIDO: "perfilindefinido",
};

export default function ({ customer }) {
  const rfv_css_class = css_classes[customer?.rfv?.profile || "INDEFINIDO"];

  return (
    <div className={styles.customerDetails}>
      <div className={styles.header}>
        <div className={styles.picture}>
          {true ? (
            <div className={styles.withoutImage}>
              <i className="fas fa-user" />
            </div>
          ) : (
            <div className={styles.withImage}></div>
          )}
        </div>
        <div className="d-flex flex-column">
          <p className={styles.name}>{customer.name || "---"}</p>
          <p className={styles.phone}>{Phone.format(customer.phone)}</p>
        </div>
      </div>

      <div className={css({ badge: true, [rfv_css_class]: true })}>
        <div className={styles.icon}>
          {/* <ProfileType /> */}
          <i className="fal fa-medal" />
        </div>
        <span>
          {RFV_LABELS[customer?.rfv?.profile] || RFV_LABELS.INDEFINIDO}
        </span>
      </div>

      <RFV customer={customer} />
    </div>
  );
}
